var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eligible)?_c('div',{staticClass:"grid-container"},[_c('MapSelectParams',{staticClass:"q1"}),_c('KG_Map',{ref:"mapInstance",staticClass:"q2 maps-area"}),_c('MapCharts',{staticClass:"q3"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }